import { NgModule } from '@angular/core';
import { TabsComponent } from './tabs.component';
import { TabsViewComponent } from './tab-view.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [TabsComponent, TabsViewComponent],
  exports: [TabsComponent, TabsViewComponent],
  imports: [BrowserModule, BrowserAnimationsModule, FormsModule, TranslateModule, SharedModule],
  providers: []
})
export class TabsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/tabs/tabs.module.ts